// @ts-strict-ignore
import { useSelector } from 'react-redux';
import { GlobalState } from '../redux/GlobalState';

export const useSnexStore = <TResult>(selector?: (s: GlobalState) => TResult): TResult => {
    return useSelector((s: GlobalState) => (selector ? selector(s) : null));
};
